import * as React from "react";
import type { SVGProps } from "react";
const LightPanelIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M8.21 10.579 4 6.369l5.895-3.37 1.684 1.685-.518.907q.106.045.202.12l8.42 6.736c.346.276.419.771.169 1.135L16.127 19h1.347a.842.842 0 0 1 0 1.684H6.526a.842.842 0 1 1 0-1.684H7.79v-.842a.842.842 0 1 1 1.685 0V19h4.61l3.936-5.727-7.789-6.23z" clipRule="evenodd" /></svg>;
export default LightPanelIcon;